import { Model } from '../general'
import { I18nStore } from '../i18n'

interface RootStore {
  i18n: I18nStore
}

export interface Data {
  id: number
  email?: string
  language?: string
  role_id?: number
  location_id?: number
}

class UserInvite extends Model<Data, RootStore> {
  get email() {
    return this.data.email
  }

  get language() {
    return this.data.language || this.store.i18n.language
  }

  get roleId() {
    return this.data.role_id
  }

  get locationId() {
    return this.data.location_id
  }
}

export default UserInvite
